import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN as string | undefined,
  environment: import.meta.env.MODE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,   // hide PII in session replays
      blockAllMedia: true,
    }),
  ],
  tracesSampleRate: 0.1,          // 10% of transactions
  replaysOnErrorSampleRate: 1.0,  // always capture replay on error
});

// Prevent bfcache (back-forward cache) from restoring a stale page snapshot.
// When the browser restores from bfcache, event.persisted is true — force reload.
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    window.location.reload();
  }
});
import { SpeedInsights } from '@vercel/speed-insights/react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,            // data is fresh for 30s; refetch on mount if older
      refetchOnWindowFocus: false,  // don't refetch when tab regains focus
      refetchOnReconnect: false,    // don't refetch on network reconnect
      refetchOnMount: true,         // refetch on navigation if data is stale
      retry: (failureCount, error) => {
        if (error instanceof Error && 'status' in error) {
          const status = (error as { status: number }).status;
          if (status >= 400 && status < 500) return false;
        }
        return failureCount < 2;
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster richColors position="top-right" />
        <SpeedInsights />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
